export default Object.freeze({
  Physical: 1,
  Postal: 2,  
});
